module.exports = __webpack_public_path__ + "assets/index/img/head-future-1.svg";


//////////////////
// WEBPACK FOOTER
// ./resources/images/modals/head-future-1.svg
// module id = 145
// module chunks = 0